(() => {
  if (customElements.get('nue-card-option-swatches')) return;

  class NueCardOptionSwatches extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.displayMode = this.dataset.displayMode || 'color';
      this.buttons = Array.from(this.querySelectorAll('[data-nue-card-swatch]'));
      this.card = this.closest('product-card');

      requestAnimationFrame(() => {
        const content = this.closest('.product-card__content');
        const gallery = content?.querySelector(':scope > .card-gallery');
        if (gallery && gallery.nextElementSibling !== this) {
          gallery.insertAdjacentElement('afterend', this);
        }
        this.applyVisuals();
      });

      this.buttons.forEach((button) => {
        button.addEventListener('click', this.handleClick);
      });

      if (!window.NueVariantColors) {
        window.addEventListener('nue:variant-colors-ready', this.handlePaletteReady, { once: true });
      }
    }

    disconnectedCallback() {
      this.buttons?.forEach((button) => button.removeEventListener('click', this.handleClick));
      window.removeEventListener('nue:variant-colors-ready', this.handlePaletteReady);
      delete this.dataset.initialized;
    }

    handlePaletteReady = () => this.applyVisuals();

    applyVisuals() {
      this.buttons?.forEach((button) => {
        const imageUrl = button.dataset.imageUrl;
        const color = window.NueVariantColors?.resolve(button.dataset.value);

        if (this.displayMode === 'variant_image' && imageUrl) {
          button.style.setProperty('--nue-card-swatch-background', `url("${imageUrl}")`);
          return;
        }

        if (color) {
          button.style.setProperty('--nue-card-swatch-background', color);
        } else if (imageUrl) {
          button.style.setProperty('--nue-card-swatch-background', `url("${imageUrl}")`);
        }
      });
    }

    handleClick = (event) => {
      event.preventDefault();
      event.stopPropagation();

      const button = event.currentTarget;
      if (!(button instanceof HTMLButtonElement)) return;

      this.buttons.forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      const mediaId = button.dataset.mediaId;
      const slideshow = this.card?.querySelector('slideshow-component');

      if (slideshow && mediaId) {
        slideshow.querySelectorAll('slideshow-slide[variant-image]').forEach((slide) => {
          slide.hidden = slide.getAttribute('slide-id') !== mediaId;
        });

        const selectedSlide = slideshow.querySelector(`slideshow-slide[slide-id="${CSS.escape(mediaId)}"]`);
        if (selectedSlide) selectedSlide.hidden = false;

        if (typeof slideshow.select === 'function') {
          slideshow.select({ id: mediaId }, undefined, { animate: false });
        }
      }

      const variantUrl = button.dataset.variantUrl;
      if (this.card && variantUrl) {
        this.card
          .querySelectorAll('[ref="productCardLink"], [ref="cardGalleryLink"], [ref="productTitleLink"]')
          .forEach((link) => {
            if (link instanceof HTMLAnchorElement) link.href = variantUrl;
          });
      }

      const imageUrl = button.dataset.imageUrl;
      if (this.card && imageUrl) {
        this.card.setAttribute('data-featured-media-url', imageUrl);
      }
    };
  }

  customElements.define('nue-card-option-swatches', NueCardOptionSwatches);
})();
